import { z } from 'zod'
import {
  CN_MOBILE_PATTERN,
  PHONE_LIMITS,
  isCnMobile,
  isContactTel,
  isPublicTel,
  isSupportPhone,
} from '@/utils/phone'
import { codePointLength, trimForValidate } from '@/utils/stringLength'

export { PHONE_LIMITS, CN_MOBILE_PATTERN, isCnMobile } from '@/utils/phone'

/** 中国大陆 11 位手机号（必填） */
export const cnMobileSchema = z
  .string()
  .transform(trimForValidate)
  .pipe(
    z
      .string()
      .min(1, '请输入手机号')
      .length(PHONE_LIMITS.cnLength, `手机号须为 ${PHONE_LIMITS.cnLength} 位`)
      .regex(CN_MOBILE_PATTERN, '请输入正确的11位手机号'),
  )

/** 境内联系电话（必填，与接口 CONTACT_PHONE_INPUT_MAX=20 一致） */
export const contactPhoneInputSchema = z
  .string()
  .transform(trimForValidate)
  .pipe(
    z
      .string()
      .min(1, '请输入联系电话')
      .max(
        PHONE_LIMITS.contactPhoneInputMax,
        `联系电话不能超过 ${PHONE_LIMITS.contactPhoneInputMax} 个字符`,
      )
      .refine(isContactTel, '联系电话格式不正确'),
  )

/** 联系电话（必填）：大陆手机或国际格式 */
export const contactTelSchema = z
  .string()
  .transform(trimForValidate)
  .pipe(
    z
      .string()
      .min(1, '请输入联系电话')
      .max(
        PHONE_LIMITS.contactTelMaxLength,
        `联系电话不能超过 ${PHONE_LIMITS.contactTelMaxLength} 个字符`,
      )
      .refine(isContactTel, '联系电话格式不正确'),
  )

/** 选填境外电话（库/接口 20） */
export const optionalOverseasPhoneSchema = z
  .string()
  .transform(trimForValidate)
  .pipe(
    z
      .string()
      .max(
        PHONE_LIMITS.overseasPhoneMaxLength,
        `境外电话不能超过 ${PHONE_LIMITS.overseasPhoneMaxLength} 个字符`,
      )
      .refine((v) => !v || isContactTel(v), '境外电话格式不正确'),
  )

/** 选填联系电话 */
export const optionalContactTelSchema = z
  .string()
  .transform(trimForValidate)
  .pipe(
    z
      .string()
      .max(
        PHONE_LIMITS.contactTelMaxLength,
        `联系电话不能超过 ${PHONE_LIMITS.contactTelMaxLength} 个字符`,
      )
      .refine((v) => !v || isContactTel(v), '联系电话格式不正确'),
  )

/** 公示 / 热线 / SOS（必填，至少 4 个有效字符） */
export const publicTelSchema = z
  .string()
  .transform(trimForValidate)
  .pipe(
    z
      .string()
      .min(1, '请输入电话号码')
      .max(
        PHONE_LIMITS.publicTelMaxLength,
        `电话号码不能超过 ${PHONE_LIMITS.publicTelMaxLength} 个字符`,
      )
      .refine(isPublicTel, '请输入合理的电话号码'),
  )

/** 选填公示电话 */
export const optionalPublicTelSchema = z
  .string()
  .transform(trimForValidate)
  .pipe(
    z
      .string()
      .max(
        PHONE_LIMITS.publicTelMaxLength,
        `电话号码不能超过 ${PHONE_LIMITS.publicTelMaxLength} 个字符`,
      )
      .refine((v) => !v || isPublicTel(v), '请输入合理的电话号码'),
  )

/** 技术支持电话（手机 / 400 / 固话） */
export const supportPhoneSchema = z
  .string()
  .transform(trimForValidate)
  .pipe(
    z
      .string()
      .min(1, '请输入技术支持电话')
      .max(
        PHONE_LIMITS.publicTelMaxLength,
        `电话号码不能超过 ${PHONE_LIMITS.publicTelMaxLength} 个字符`,
      )
      .refine(isSupportPhone, '请输入正确的电话号码'),
  )

/** 短信验证码 6 位数字 */
export const smsOtpSchema = z
  .string()
  .transform(trimForValidate)
  .pipe(
    z
      .string()
      .length(PHONE_LIMITS.otpLength, `验证码须为 ${PHONE_LIMITS.otpLength} 位`)
      .regex(/^\d+$/, '验证码须为数字'),
  )

/** 紧急联系方式（微信/电话/邮箱混合，选填） */
export const optionalEmergencyContactSchema = z
  .string()
  .transform(trimForValidate)
  .pipe(
    z
      .string()
      .max(
        PHONE_LIMITS.emergencyContactMaxLength,
        `紧急联系方式不能超过 ${PHONE_LIMITS.emergencyContactMaxLength} 个字符`,
      ),
  )

/** 精确检索关键字（身份证 18 / 手机 11） */
export const exactIdentitySearchSchema = z
  .string()
  .transform(trimForValidate)
  .pipe(
    z
      .string()
      .max(
        PHONE_LIMITS.exactIdentitySearchMaxLength,
        `检索关键字不能超过 ${PHONE_LIMITS.exactIdentitySearchMaxLength} 个字符`,
      ),
  )
